import { FC } from 'react'
import Footer from '../../components/Footer'
import BottomInfo from '../../components/info/BottomInfo'
import AppContent from './AppContent'

const AppContainer: FC = () => (
  <div className="w-full h-screen">
    <div className="h-[95%] overflow-auto px-4">{<AppContent />}</div>
    <Footer />
    <BottomInfo />
  </div>
)

export default AppContainer
